























































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Select2, TextArea, Radio } from '@/components/form'
import { DatePicker } from '@/components/general'
import HeaderFormSelectArea from '../HeaderFormSelectArea.vue'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

// models
import { PermissionControlForm } from '@/models/dailyControl'
import { AreaModel, IEmployee, ReasonForPermissionModel } from '@/models/config'
import { PropOptionSelect } from '@/models'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'
import { getListDateAvailable } from '@/utils/employee'

// services
import { PermissionControlsService } from '@/services/dailyControl'
import { AreaService } from '@/services/config'

@Component({
    name: 'FormCreateEditPermissionControl',
    components: {
        Input,
        Select2,
        DatePicker,
        TextArea,
        Radio,
        HeaderFormSelectArea
    },
    mixins: [validationMixin]
})
export default class FormCreateEditPermissionControl extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) permissionControl!: PermissionControlForm
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ type: Array, default: () => [] }) employees!: IEmployee[]
    @Prop({ type: Array, default: () => [] }) reasons!: ReasonForPermissionModel[]

    form: PermissionControlForm = {
        employee_id: null,
        date_start: '',
        date_end: '',
        reason_id: null,
        observations: '',
        valido: 0
    }

    typeForm = 1
    optionsTypeForm = [
        {
            text: 'POR EMPLEADO',
            value: 1
        },
        {
            text: 'POR ÁREA',
            value: 2
        }
    ]

    validOptions = [
        {
            text: 'Sí',
            value: 1
        },
        {
            text: 'No',
            value: 0
        }
    ]

    dateAvailable: string[] = []
    areas: AreaModel[] = []
    areaSelectedId: number|null = null
    subAreaSelectedId: number|null = null
    employeesSelected: number[] = []
    async getAreas () {
        this.areas = await AreaService.getActivated()
    }

    get areasOp (): PropOptionSelect[] {
        return this.areas.map(area => ({
            value: area.id ?? null,
            text: area.name
        }))
    }

    get subAreasOP (): PropOptionSelect[] {
        if (this.areaSelectedId) {
            const area = this.areas.find(area => Number(area.id) === Number(this.areaSelectedId))
            if (area) {
                return area.subAreas && area.subAreas.length > 0 ? area?.subAreas.map(area => ({
                    value: area.id ?? null,
                    text: area.name
                })) : []
            }
        }
        return []
    }

    get reasonsOp (): PropOptionSelect[] {
        return this.reasons.map(reason => {
            return {
                value: reason.id ?? 0,
                text: `${reason.description} - (${reason.abbreviated})`
            }
        })
    }

    get employeesOp (): PropOptionSelect[] {
        return this.employees.filter(employee => this.actionForm === 'save' && this.typeForm === 2 ? Number(employee.assignment.sub_area_id) === Number(this.subAreaSelectedId) : true).map(employee => {
            return {
                value: employee.id ?? null,
                text: getFullNameFormat(employee)
            }
        })
    }

    setAllEmployeesBySubArea (subAreaSelectedId: number) {
        this.subAreaSelectedId = subAreaSelectedId
        if (subAreaSelectedId) {
            this.employeesSelected = this.employees.filter(employee => Number(employee.assignment.sub_area_id) === Number(subAreaSelectedId)).map(employee => employee.id)
        } else {
            this.employeesSelected = []
        }
    }

    get employeeSelected (): IEmployee | null {
        if (this.form.employee_id && this.employeesOp.find(employee => employee.value === this.form.employee_id)) {
            const employee = this.employees.find(e => e.id === this.form.employee_id)
            if (employee) {
                return employee
            }
        }
        return null
    }

    created () {
        this.getAreas()
        if (this.idEdit) {
            this.form = this.permissionControl
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                date_start: { required },
                date_end: { required },
                employee_id: {
                    required: requiredIf(() => this.actionForm !== 'save' || this.typeForm === 1)
                },
                reason_id: { required }
            },
            areaSelectedId: {
                required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2)
            },
            subAreaSelectedId: {
                required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2)
            },
            employeesSelected: { required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2), minLength: 1 }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await PermissionControlsService.update(this.idEdit, this.form)
                } else {
                    if (this.typeForm === 2) {
                        for (let i = 0; i < this.employeesSelected.length; i++) {
                            this.form.employee_id = this.employeesSelected[i]
                            await PermissionControlsService.create(this.form)
                        }
                    } else {
                        await PermissionControlsService.create(this.form)
                    }
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    employee_id: null,
                    date_start: '',
                    date_end: '',
                    reason_id: null,
                    observations: '',
                    valido: 0
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error(String(e))
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    setListDateAvailable () {
        if (this.form.employee_id && this.employeeSelected) {
            const listDate = getListDateAvailable(this.employeeSelected.cessation)
            this.dateAvailable = listDate
        }
    }
}
